import script from "./copyRightBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./copyRightBar.vue?vue&type=script&setup=true&lang=ts"

import "./copyRightBar.vue?vue&type=style&index=0&id=197a3eea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-197a3eea"]])

export default __exports__